import { Injectable } from "@angular/core";
import { BehaviorSubject, filter, take } from "rxjs";
import { show, showArticle } from "@intercom/messenger-js-sdk";

@Injectable({
  providedIn: "root",
})
export class IntercomService {
  private readySubject = new BehaviorSubject<boolean>(false);
  intercomReady$ = this.readySubject.asObservable();

  setReady(isReady: boolean): void {
    this.readySubject.next(isReady);
  }

  openMessenger(): void {
    if (this.readySubject.value) {
      show();
      return;
    }

    this.intercomReady$
      .pipe(
        filter((ready) => ready),
        take(1),
      )
      .subscribe(() => show());
  }

  openArticle(articleId: string): void {
    if (this.readySubject.value) {
      showArticle(articleId);
      return;
    }

    this.intercomReady$
      .pipe(
        filter((ready) => ready),
        take(1),
      )
      .subscribe(() => showArticle(articleId));
  }
}
